
import SubscriptionService from "../../../services/subscription.service";

export default {
    async getListSubscriptions({ dispatch, commit }, data) {
        return await SubscriptionService.getListSubscriptions()
            .then(response => {
                if (response.success && response.data) {
                    return Promise.resolve(response.data);
                } else {
                    dispatch("alertError", response.message, { root: true });
                }
            }).catch(error => {
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },
    async fetchSubscriptions({ commit, dispatch }, payload) {
        return SubscriptionService.getSubscriptions(payload)
            .then(response => {
                commit('SET_SUBSCRIPTION', response.data.data)
                commit('SET_INFO_DB', { totalPage: response.data.last_page, totalRow: response.data.total })
                return Promise.resolve(response.data.data)
            })
            .catch(error => {
                if (Object.values(error.errors).length > 0) {
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    async addSubscriptions({ dispatch }, params) {
        return SubscriptionService.createSubscriptions(params)
            .then(response => {
                dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (Object.values(error.errors).length > 0) {
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    async showSubscriptions({ dispatch }, id) {
        return SubscriptionService.showSubscriptions(id)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    async updateSubscriptions({ commit, dispatch }, data) {
        return SubscriptionService.updateSubscriptions(data)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },

    async removeSubscriptions({ commit, dispatch }, ids) {
        return SubscriptionService.deleteSubscriptions(ids)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },

    async registerSubscription({ dispatch }, payload) {
        return await SubscriptionService
            .registerSubscription(payload)
            .then((response) => {
                dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
                return Promise.resolve(response)
            })
            .catch((error) => {
                dispatch('alertError', error.response.data.message[0] || error, { root: true })
                return Promise.reject(error)
            })
    },
    async confirmSubscription({ dispatch }, payload) {
        return await SubscriptionService
            .confirmSubscription(payload)
            .then((response) => {
                dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
                return Promise.resolve(response)
            })
            .catch((error) => {
                dispatch('alertError', error.response.data.message[0] || error, { root: true })
                return Promise.reject(error)
            })
    },
    async getSubscriptions({ commit, dispatch }) {
        return await SubscriptionService
            .getSubscriptions()
            .then((response) => {
                commit('SET_SUBSCRIPTION', response.data)
            })
            .catch((error) => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch('alertError', Object.values(error.errors)[0][0], { root: true })
                    }
                } else dispatch('alertError', typeof error.message == 'object' ? error.message[0] : error.message, { root: true })
            })
    },
    async getSubscriptionForCustomer({ commit, dispatch }, payload) {
        return await SubscriptionService
            .getSubscriptionForCustomer(payload)
            .then((response) => {
                commit('SET_SUBSCRIPTION', response.data)
                return true
            })
            .catch((error) => {
                dispatch('alertError', error.response.data.message[0] || error, { root: true })
                return Promise.reject(error)
            })
    }
}